export const Navlinks = [
    {
      id: 1,
      name: "Home",
      link: "/",
    },
    {
      id: 2,
      name: "About",
      link: "/about",
    },
    {
      id: 3,
      name: "Shop",
      link: "/shop",
    },
    {
      id: 4,
      name: "Contact us",
      link: "/contact",
    },
    {
      id: 5,
      name: "FAQ",
      link: "/faq",
    },
    // {
    //   id: 4,
    //   name: "Redeem Rewards",
    //   link: "/rewardspage",
    // },
    // {
    //   id: 5,
    //   name: "Leaderboard",
    //   link: "/#Leaderboard",
    // },
    // {
    //   id: 4,
    //   name: "REVIEW",
    //   link: "/#boo",
    // },
  ];